var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSocializationExercise = function SvgSocializationExercise(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 106,
    height: 99,
    viewBox: "0 0 106 99"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#76BF43",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M39.95 30.68c3.63.53 6.77-1.52 7.77-2.83l4.23-1.9a8.38 8.38 0 0 0 4.96-9.4c-.15-.69-.35-1.15-.62-1.15-1.06 0-9.1 1.8-9.6 1.76-.48-.04-2.27-.57-3.57-1.29-1.3-.72-6 1.18-6 1.18s-2.61-3.78-3.73-6.23c-1.51-2.71-5.26 5.22-.7 9.23 0 0-.94 5.3.66 9.48.27 2.72-3.09 5.83-2.85 11.97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#76BF43",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M37.03 10.4c.27-.46 1.2-1.4 1.2-1.4 1.04-.9 2.13-1.07 2.17-.04-.08 1.67.14 2.93.23 3.71M36.1 41.96s-.34 4.2-3.34 4.2-10.19-7.13-14.38-2.85c-4.19 4.28-6.33 17.12-3.98 19.56 1.17 1.23 2.7.77 3.96-.3 1.64-1.4 2.14-3.67 1.76-5.8-.54-2.97.49-5.5 2.45-6.43 2.35-1.12 7 4.12 11.03 4.86 3.48.64 6.55-3.7 9.1-3.4M26.97 37.48c-2.26-2.03-5.34-4.64-6.83-5.16-1.6-.56-7.82-1-12.55-.35-2.67.37-4.95 1.3-5.52 2.12-.53 2 1.87 4 4.56 4.9 1.83.6 3.78.25 5.55-.54 1.8-.8 3.82-.38 5.54.78"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#76BF43",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M33.6 55.2c6.43 13.03 29.36 11.34 31.34 16.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#76BF43",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M62.4 64.78s3.81 13.04 7.9 14.12c4.09 1.09 14.04-2.57 16.77-1.75 2.73.81 8.71 11.54 14.85 9.09 6.13-2.44-2.46-6.93-3.41-6.66-.95.28-5.8-6.86-7.97-9.16-2.18-2.31-7.76 2.16-9.94-.49-1.23-1.49-1.26-3.42-1.34-5.67-.22-5.79-2.68-11.62-8-13.96a61.62 61.62 0 0 0-12.92-3.88c-2.76-.52-7.97-3.05-10.18-7.12-2.6-4.76-.42-11.27-.42-11.27"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#76BF43",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M52.55 70.72c.2 3.87.84 8.61 2.76 9.9 3.39 2.25 13.61 2 15.85 3.6 2.23 1.58 4.35 13.22 10.7 12.9 6.36-.34-.07-7.1-1.03-7.14-.65-.03-1.89-3.82-3-7.09M73.9 51.92c5.1 5.02 24.25 7.8 26.12-11.25 5.75 16.65-7.82 27.1-21.75 17.92M97.67 5.28c.37 2.35-5.72 5.26-13.6 6.51-7.89 1.25-14.58.36-14.96-2-.37-2.35 5.72-5.26 13.6-6.51 7.89-1.25 14.58-.36 14.96 2ZM99.94 10.73c-.33.3-.7.62-1.13.93M95.38 13.58a26.82 26.82 0 0 1-2.87 1.13c-.97.35-2.02.68-3.13.97M67.05 4.53A15.93 15.93 0 0 1 71.16 2"
  })));
};
export default SvgSocializationExercise;